var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.actionList),function(item){return _c('el-dropdown-item',{key:item.index,nativeOn:{"click":function($event){return _vm.setAction(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }